import React from 'react'
import { Schedule } from '../../components'

const SchedulePlane = () => {
  return (
    <div>
      <Schedule />
    </div>
  )
}

export default SchedulePlane